import { IMAGE_NOT_ALLOWED_FOR } from "../constants/const";
import {
  audioExtensions,
  imageExtensions,
  videoExtensions,
} from "../constants/fileConstants";

const getFileExtension = (file) => {
  const normalizedFile = file?.file || file;
  const value = typeof normalizedFile === "string" ? normalizedFile : normalizedFile?.name || "";
  const path = value.split(/[?#]/, 1)[0];
  return path.split(".").pop()?.toLowerCase() || "";
};

export const getFileModelCompatibilityError = (file, model) => {
  const normalizedFile = file?.file || file;
  const mimeType = typeof normalizedFile === "string"
    ? ""
    : normalizedFile?.type || normalizedFile?.mime_type || "";
  const extension = getFileExtension(file);
  const isImage = mimeType.startsWith("image/") || imageExtensions.includes(extension);
  const isVideo = mimeType.startsWith("video/") || videoExtensions.includes(extension);
  const isAudio = mimeType.startsWith("audio/") || audioExtensions.includes(extension);

  if (isImage && IMAGE_NOT_ALLOWED_FOR?.[model?.company_name]) {
    return `Image uploads are not allowed when using ${model?.company_name} models!`;
  }

  if ((isVideo || isAudio) && model?.company_name !== "Google") {
    return `${isVideo ? "Video" : "Audio"} files can only be used with Google Gemini models. Please switch your model and try again.`;
  }

  return null;
};

export const getFilesModelCompatibilityError = (files, model) => {
  for (const file of files || []) {
    const error = getFileModelCompatibilityError(file, model);
    if (error) return error;
  }
  return null;
};